import { dateSpine, queryStatus } from './growthAnalytics';

// GA can return a valid provisional count while its reporting window is open.
// Keep this separate from Store metrics, whose delayed values remain unknown.
export function measuredWebNumber(metric) {
  return ['ok', 'delayed'].includes(metric?.status) && typeof metric.value === 'number' &&
    Number.isFinite(metric.value) && metric.value >= 0 ? metric.value : null;
}

export function landingMetric(query, key, row = query?.data?.summary) {
  const state = query ? queryStatus(query) : 'not_collected';
  const metric = row?.[key];
  return {
    value: state === 'ok' ? measuredWebNumber(metric) : null,
    status: state === 'ok' ? metric?.status || (query?.data?.source?.status === 'ok' ? 'not_collected' : query?.data?.source?.status) || 'not_collected' : state,
  };
}

// The signup provider returns sparse DATE(created_at) groups. Only a valid,
// successful response makes absent days zero; failed/malformed reports stay unknown.
export function signupReport(data, from, to) {
  if (!Array.isArray(data?.series)) throw new Error('Invalid signup report contract');
  const days = dateSpine(from, to);
  const counts = new Map();
  for (const row of data.series) {
    if (!days.includes(row?.date) || !Number.isSafeInteger(row.count) || row.count < 0 || counts.has(row.date)) {
      throw new Error('Invalid signup report row');
    }
    counts.set(row.date, row.count);
  }
  const daily = days.map((date) => ({ date, count: counts.get(date) ?? 0 }));
  const total = daily.reduce((sum, row) => sum + row.count, 0);
  if (!Number.isSafeInteger(total)) throw new Error('Invalid signup report total');
  return { total, daily, from, to };
}

export function acquisitionChartRows(from, to, landingQuery, signupQuery) {
  return dateSpine(from, to).map((date) => {
    const landing = !landingQuery?.error && landingQuery?.data?.daily?.find((row) => row.date === date);
    const signup = !signupQuery?.error && signupQuery?.data?.daily?.find((row) => row.date === date);
    return {
      date,
      landing: measuredWebNumber(landing?.landing_sessions),
      iosClicks: measuredWebNumber(landing?.ios_store_click_sessions),
      androidClicks: measuredWebNumber(landing?.android_store_click_sessions),
      signups: signup?.count ?? null,
    };
  });
}
